export default __webpack_public_path__ + "static/media/gear.2de585d5.svg";